<template lang="pug">
  .apply-report
    .success-submit(v-if="submitted")
      i(class="el-icon-success" style="color:#67C23A;margin:0 10px").success-icon
        span 已成功将报告发送至您的邮箱
      el-button(type="primary" @click="show") 再次申请
    el-form(v-show="!submitted" :loading="submitLoading" ref="formRef" :model="form" :rules="rules" @submit.prevent="submitData")
      el-form-item(label="发起人:" prop="originator_union_id")
        .flex-between-end(style="width:12rem;")
          span(style="color: #409eff; font-weight: 600; width:3rem;") {{ form.originator_name }}
        .apply_limit(style="width:100%;") 今天已申请报告数 {{applyReportCounts}}/ {{ Apply_Limit_Count }}
      el-form-item(label="邮箱:" prop="email")
        div
          el-input.keywords-input(v-model="form.email" placeholder="请输入邮箱")
          .tips(style="color: #e6a23c") 受邮箱可接收附件大小限制，建议使用网易/qq/搜狐/新浪邮箱，以免附件过大导致接收不到邮件
      el-form-item(label="报告:")
        el-input.keywords-input(v-model="searchData.title" placeholder="关键字" @keyup.enter="onSearch")
        el-button(type="primary" style="margin-left: 0.2rem" @click="onSearch" :loading="loading") 搜索
      el-form-item(label="选中报告" prop="id")
        template(v-if="form.title")
          span(style="color: #409eff; font-weight: 600;") {{ form.title }}
          span(style="margin-left: 8px;") (主笔人：{{ form.author || '-' }})
        template(v-else)
          span -
      .total-num 共找到 {{ reportList.length }} 本报告
      el-table(v-if="reportList.length" key="report" :data="reportList" highlight-current-row @current-change="onSelectReport")
        el-table-column(label="" width="40" class-name="select-column")
          template(slot-scope='scope')
            .check-border.selected
        el-table-column(prop="title" label="报告")
          template(slot-scope='scope')
            span {{scope.row.title}}
        el-table-column(prop="PDFName" label="原稿")
          template(slot-scope='scope')
            span {{ scope.row.PDFName ? scope.row.PDFName  : '暂无原稿' }}
        el-table-column(prop="chief_editor" label="主笔人")
          template(slot-scope='scope')
            span {{ scope.row.author ? scope.row.author  : '未指派' }}
        el-table-column(prop="updated_at" label="更新时间")
          template(slot-scope='scope')
            span {{ scope.row.updatedAt ? new Date(scope.row.updatedAt).toLocaleString()  : '暂无' }}
      span.dialog-footer(v-if="!submitted")
        el-button.send-email(type='primary' @click="submitData" :loading="submitLoading") 发送邮箱
  </template>
<script>
import api from '@/apis/apply'

export default {
  created () {
    if (localStorage.passport) {
      const token = localStorage.passport
      this.userInfo = this.$jwt.decode(token)
      this.show()
    }
  },
  data () {
    return {
      applyVisible: false,
      userInfo: '',
      applyReportCounts: 0,
      loading: false,
      reportList: [],
      formRef: null,
      submitted: false,
      submitLoading: false,
      searchData: {
        writtenDate: '',
        title: '',
        industryId: [],
        status: [],
        briefType: [],
        kind: -1,
        checkList: [],
        // freeStatus: ['isfree', 'nofree'],
        releasedStatus: ['isreleased', 'noreleased'],
        sortwhere: { order: 'descending', prop: 'createdAt' },
        currentPage: 1
      },
      rules: {
        id: { required: true, message: '请选择报告', trigger: 'blur' },
        email: [
          { required: true, message: '请正确的输入邮箱', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ],
        originator_union_id: {
          required: true,
          message: '请选择发起人',
          trigger: 'change'
        }
      },
      form: {},
      Apply_Limit_Count: 20
    }
  },
  methods: {
    getInitForm () {
      return {
        id: '',
        title: '',
        chief_editor: '',
        chief_editor_id: '',
        editor_corpid: '',
        editor_dept_id: '',
        editor_dept: '',
        email: '',
        originator_union_id: this.userInfo.unionId,
        originator_name: this.userInfo.name
      }
    },
    show () {
      this.form = this.getInitForm()
      this.searchData.title = ''
      this.reportList = []
      this.submitted = false
      this.applyVisible = true
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate()
        this.getApplyReportCounts()
      })
    },
    submitData () {
      // 判断rules的校验结果
      this.$refs.formRef.validate(valid => {
        if (valid) {
          if (this.applyReportCounts >= 20) {
            this.$message({ type: 'error', message: '今日申请已达上限，请明天再来' })
            return
          }
          this.submitLoading = true
          const data = this.getInitForm()
          for (const key in data) {
            data[key] = this.form[key]
          }
          api.applyReport(data)
            .then(res => {
              console.log(res)
              if (res.errCode !== 0) {
                this.$message({ type: 'error', message: res.message || res.msg })
                return
              }
              if (res.data && res.data.errCode === -1) {
                return this.$message({ type: 'error', message: res.data.message })
              }
              this.$message({ type: 'success', message: '已发送到邮箱' })
              this.submitted = true
            })
            .finally(() => {
              this.submitLoading = false
            })
        }
      })
    },
    onSearch () {
      if (!this.searchData.title) return
      this.loading = true
      // this.searchData.
      // 添加monogo条件ossUrl必须存在
      api.getReportPage({ queryParams: this.searchData })
        .then(res => {
          if (res.errCode !== 0) return
          this.reportList = res.data.data || []
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSelectReport (report) {
      if (!report) return
      report.id = report._id
      this.form = Object.assign({}, this.form, report)
    },
    spellTitle (row) {
      let info = row.title + this.typeChange(
        Number(row.briefType)
      )
      info = info.toString()
      return info
    },
    typeChange (type) {
      if (typeof type !== 'number') return ''
      const ReportType = [
        { value: 0, label: '短报告' },
        { value: 1, label: '普通报告' },
        { value: 2, label: '深度报告' },
        { value: 3, label: '简报' },
        { value: 4, label: '白皮书' },
        { value: 5, label: '头豹推荐' }
      ]
      return (ReportType.find(item => item.value === type) || {}).label || ''
    },
    getApplyReportCounts () {
      api.reqGetApplyCounts().then(res => {
        if (res.errCode !== 0) return
        this.applyReportCounts = res.data
      })
    }
  }
}
</script>
  <style scoped>
  .flex-between-end {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .keywords-input {
    min-width: 9.5rem;
    max-width: 20rem;
  }
  .check-border {
    width: 16px;
    height: 16px;
    border: 1px solid #666;
    border-radius: 50%;
  }
  tr.current-row .selected {
    display: block;
    border: 5px solid #409eff;
  }
  .el-table :deep() tr {
    cursor: pointer;
  }
  .success-submit {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 10%;
  }
  .success-icon {
    width: 230px;
    color: #95d475;
    margin-bottom: 10px;
  }
  .success-submit .el-button {
    margin-top: 16px;
  }
  .apply-report {
    width: 100%;
    height: 100%;
    padding: .3rem;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    justify-content: center;
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 40px;
  }
  .total-num {
    font-size: 14px;
  }
  .staff-table :deep() thead {
    display: none;
  }

  .apply_limit {
    font-size: 14px;
    font-weight: 400;
    color: #707e98;
    line-height: 32px;
    margin-left: 10px;
}
  </style>
